import {DEFAULT_CLIENT_URL_STRING_KEY, DEFAULT_HOTLINE_KEY} from '@components/Organizations/constants';

import {SET_CURRENT_PERSONA} from '@redux/modules/session/types';

import * as types from './types';

const organizationReducer = (
  state = {
    isFetching: false,
    isFetchingOrganizationInfo: false,
    isSavingOrganizationData: false,
    creatingCustomRole: false,
    isFetchingOrgHierarchy: false,
    isFetchingOrgChildren: false,
    list: [],
    tree: [],
    treeWithIds: [],
    hierarchy: {},
    parentHierarchy: {},
    dict: {},
    error: null,
    organizationInfo: {},
    organizationUsers: [],
    isFetchingUsers: false,
    isFetchingOrgRoles: false,
    organizationSubscriptions: {},
    isFetchingOrgSubscriptions: false,
    orgRoles: [],
    roleColumns: [],
    permissionHierarchy: [],
    roleUserCount: 0,
    roleDetail: {},
    sortField: undefined,
    direction: 'ascend',
    updatingCustomRole: false,
    pageable: {
      pageNumber: 0,
      pageSize: 25,
    },
    organizationActiveSeats: {count: 0},
    isFetchingActiveSeats: false,
    updatingMaxSeats: false,
  },
  action,
) => {
  switch (action.type) {
    case types.CHILDREN_REQUEST:
      return {
        ...state,
        isFetchingOrgChildren: true,
        error: null,
      };

    case types.CHILDREN_SUCCESS:
      return {
        ...state,
        isFetchingOrgChildren: false,
        list: action.payload.list,
        tree: action.payload.tree,
        treeWithIds: action.payload.treeWithIds,
        dict: action.payload.dict,
        pageable: action.payload.pageable,
        sortField: action.payload.sortField,
        direction: action.payload.direction,
      };

    case types.CHILDREN_FAILURE:
      return {
        ...state,
        isFetchingOrgChildren: false,
        list: [],
        tree: [],
        treeWithIds: [],
        dict: {},
        error: action.error,
        pageable: {},
      };

    case types.HIERARCHY_REQUEST:
      return {
        ...state,
        hierarchy: {},
        isFetchingOrgHierarchy: true,
        error: null,
      };

    case types.HIERARCHY_SUCCESS:
      return {
        ...state,
        isFetchingOrgHierarchy: false,
        hierarchy: action.payload.data,
      };

    case types.HIERARCHY_FAILURE:
      return {
        ...state,
        isFetchingOrgHierarchy: false,
        hierarchy: {},
        error: action.error,
      };

    case types.PARENT_HIERARCHY_REQUEST:
      return {
        ...state,
        parentHierarchy: {},
        isFetching: true,
        error: null,
      };

    case types.PARENT_HIERARCHY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        parentHierarchy: action.payload.data,
      };

    case types.PARENT_HIERARCHY_FAILURE:
      return {
        ...state,
        isFetching: false,
        parentHierarchy: {},
        error: action.error,
      };

    case types.GET_ORGANIZATION_REQUEST:
      return {
        ...state,
        isFetchingOrganizationInfo: true,
      };

    case types.GET_ORGANIZATION_SUCCESS:
      return {
        ...state,
        isFetchingOrganizationInfo: false,
        organizationInfo: action.payload,
      };

    case types.GET_ORGANIZATION_FAILURE:
      return {
        ...state,
        isFetchingOrganizationInfo: false,
      };

    case types.UPDATE_CLIENT_URL_AND_HOTLINE_REQUEST:
    case types.UPDATE_CLIENT_URL_STRING_REQUEST:
    case types.UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_REQUEST:
      return {
        ...state,
        isSavingOrganizationData: true,
      };

    case types.UPDATE_CLIENT_URL_AND_HOTLINE_FAILURE:
    case types.UPDATE_CLIENT_URL_STRING_FAILURE:
    case types.UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_FAILURE:
      return {
        ...state,
        isSavingOrganizationData: false,
      };

    case types.UPDATE_CLIENT_URL_AND_HOTLINE_SUCCESS:
      return {
        ...state,
        isSavingOrganizationData: false,
        organizationInfo: {
          ...state.organizationInfo,
          [DEFAULT_CLIENT_URL_STRING_KEY]: action.payload?.[DEFAULT_CLIENT_URL_STRING_KEY],
          [DEFAULT_HOTLINE_KEY]: action.payload?.[DEFAULT_HOTLINE_KEY],
        },
      };

    case types.UPDATE_CLIENT_URL_STRING_SUCCESS:
      return {
        ...state,
        isSavingOrganizationData: false,
        organizationInfo: {
          ...state.organizationInfo,
          clientUrlString: action.payload?.clientUrlString,
        },
      };

    case types.UPDATE_CLIENT_CONFIG_HOTLINE_NUMBER_SUCCESS:
      return {
        ...state,
        isSavingOrganizationData: false,
        organizationInfo: {
          ...state.organizationInfo,
          [DEFAULT_HOTLINE_KEY]: action.payload[DEFAULT_HOTLINE_KEY],
        },
      };

    case types.GET_ORGANIZATION_USERS_REQUEST:
      return {
        ...state,
        isFetchingUsers: true,
      };

    case types.GET_ORGANIZATION_USERS_SUCCESS:
    case types.GET_ORGANIZATION_USERS_FAILURE:
      return {
        ...state,
        isFetchingUsers: false,
        organizationUsers: action.payload.userList,
      };

    case types.GET_ORGANIZATION_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        isFetchingOrgSubscriptions: true,
      };

    case types.GET_ORGANIZATION_SUBSCRIPTIONS_SUCCESS:
    case types.GET_ORGANIZATION_SUBSCRIPTIONS_FAILURE:
      return {
        ...state,
        isFetchingOrgSubscriptions: false,
        organizationSubscriptions: action.payload,
      };

    case types.UPDATE_ORGANIZATION_SUBSCRIPTIONS_REQUEST:
      return {
        ...state,
        isSavingOrganizationData: true,
      };

    case types.UPDATE_ORGANIZATION_SUBSCRIPTIONS_FAILURE:
    case types.UPDATE_ORGANIZATION_SUBSCRIPTIONS_SUCCESS:
      return {
        ...state,
        isSavingOrganizationData: false,
      };

    case types.GET_ORGANIZATION_ACTIVE_SEATS_REQUEST:
      return {
        ...state,
        isFetchingActiveSeats: true,
      };
    case types.GET_ORGANIZATION_ACTIVE_SEATS_FAILURE:
      return {
        ...state,
        isFetchingActiveSeats: false,
      };

    case types.GET_ORGANIZATION_ACTIVE_SEATS_SUCCESS:
      return {
        ...state,
        organizationActiveSeats: action.payload,
        isFetchingActiveSeats: false,
      };

    case types.UPDATE_ORGANIZATION_MAX_SEATS_REQUEST:
      return {
        ...state,
        updatingMaxSeats: true,
      };

    case types.UPDATE_ORGANIZATION_MAX_SEATS_FAILURE:
      return {
        ...state,
        updatingMaxSeats: false,
      };

    case types.UPDATE_ORGANIZATION_MAX_SEATS_SUCCESS:
      return {
        ...state,
        updatingMaxSeats: false,
        organizationInfo: {...state.organizationInfo, ...action.payload},
      };

    case types.GET_ORGANIZATION_ROLES_REQUEST:
      return {
        ...state,
        isFetchingOrgRoles: true,
        orgRoles: [],
      };

    case types.GET_ORGANIZATION_ROLES_SUCCESS:
    case types.GET_ORGANIZATION_ROLES_FAILURE:
      return {
        ...state,
        isFetchingOrgRoles: false,
        orgRoles: action.payload || [],
      };

    case types.GET_ORGANIZATION_PERMISSIONS_HIERARCHY_REQUEST:
      return {
        ...state,
        isFetchingOrgRoles: true,
        permissionHierarchy: [],
      };

    case types.GET_ORGANIZATION_PERMISSIONS_HIERARCHY_SUCCESS:
    case types.GET_ORGANIZATION_PERMISSIONS_HIERARCHY_FAILURE:
      return {
        ...state,
        isFetchingOrgRoles: false,
        permissionHierarchy: action.payload || [],
      };

    case types.CREATE_CUSTOM_ROLE_REQUEST:
      return {
        ...state,
        creatingCustomRole: true,
      };

    case types.CREATE_CUSTOM_ROLE_SUCCESS:
      return {
        ...state,
        creatingCustomRole: false,
      };

    case types.CREATE_CUSTOM_ROLE_FAILURE:
      return {
        ...state,
        creatingCustomRole: false,
      };

    case types.GET_ORGANIZATION_ROLE_USER_COUNT_REQUEST:
      return {
        ...state,
        roleUserCount: 0,
      };

    case types.GET_ORGANIZATION_ROLE_USER_COUNT_SUCCESS:
      return {
        ...state,
        roleUserCount: action.payload.count,
      };

    case types.GET_ORGANIZATION_ROLE_USER_COUNT_FAILURE:
      return {
        ...state,
        roleUserCount: 0,
      };

    case types.GET_ORGANIZATION_ROLE_DETAIL_REQUEST:
      return {
        ...state,
        isFetchingOrgRoles: true,
        permissionHierarchy: [],
        roleDetail: {},
      };

    case types.GET_ORGANIZATION_ROLE_DETAIL_SUCCESS:
      return {
        ...state,
        isFetchingOrgRoles: false,
        permissionHierarchy: action.payload?.permissionHierarchy || [],
        roleDetail: action.payload?.roleDetail || {},
      };

    case types.GET_ORGANIZATION_ROLE_DETAIL_FAILURE:
      return {
        ...state,
        isFetchingOrgRoles: false,
        permissionHierarchy: [],
        roleDetail: {},
      };

    case types.UPDATE_CUSTOM_ROLE_REQUEST:
      return {
        ...state,
        updatingCustomRole: true,
      };

    case types.UPDATE_CUSTOM_ROLE_SUCCESS:
      return {
        ...state,
        updatingCustomRole: false,
      };

    case types.UPDATE_CUSTOM_ROLE_FAILURE:
      return {
        ...state,
        updatingCustomRole: false,
      };

    case SET_CURRENT_PERSONA:
      return {
        ...state,
        organizationInfo: {},
      };

    default:
      return state;
  }
};

export default organizationReducer;
